import React from 'react';
import './finish-game.css';


function FinishGame({statusGame}) {
    return (
        <div className="start-battle">
            {
                statusGame === 'win' ?
                    <h3>Parabéns você ganhou o jogo!</h3>
                    :
                    <h3>Não foi dessa vez, seu oponente foi melhor dessa vez!</h3>
            }
            <br/>
            <a href={'/'}>Voltar para a tela inicial</a>
        </div>
    );
}

export default FinishGame;